import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  VirtualConnectionDownstreamFlowsQueryVariables, VirtualConnectionDownstreamFlowsQuery, FlowsDisplayGridRowDataFragment, VirtualConnectionDownstreamFlowsFilteredByTableQueryVariables, VirtualConnectionDownstreamFlowsFilteredByTableQuery, FlowSortOrder,
  VirtualConnectionDownstreamFlowsFilteredByTableDocument,
  VirtualConnectionDownstreamFlowsDocument
} from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { FlowsDisplayGrid, FlowsDisplayGridRowData, getRowDataForFlow } from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = VirtualConnectionDownstreamFlowsQueryVariables;
type QueryResults = VirtualConnectionDownstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowDataFragment;
type GridRowData = FlowsDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionDownstreamFlowsFilteredByTableQueryVariables;
type QueryResultsWithFilter = VirtualConnectionDownstreamFlowsFilteredByTableQuery;
type QueryResultListNodeWithFilter = FlowsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  return virtualConnection ? virtualConnection.downstreamFlowsConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnections && resultData.virtualConnections[0];
  const virtualConnectionTables = virtualConnection && virtualConnection.tablesConnection && virtualConnection.tablesConnection.nodes;
  const table = virtualConnectionTables && virtualConnectionTables[0];
  return table ? table.downstreamFlowsConnection : null;
}

export type VirtualConnectionDownstreamFlowsQueryGridProps =
  GridSortProps<FlowsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function VirtualConnectionDownstreamFlowsQueryGrid(props: VirtualConnectionDownstreamFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamFlowsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredFlowsLineageGridMessage();

  return props.filteredTableId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamFlowsFilteredByTableDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedTableId: props.filteredTableId,
        orderBy: props.orderBy as FlowSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForFlow}
    >
      {({ rowStore }) => <FlowsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionDownstreamFlowsDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as FlowSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForFlow}
    >
      {({ rowStore }) => <FlowsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
